
export default function VerifiedCommunity() {
  const benefits = [
    {
      icon: 'ri-car-line',
      title: 'Car Ownership Verification',
      description: 'Membership confirmed through official car ownership records, ensuring every driver is legitimate and accountable.',
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Corporate-Rate Discounts',
      description: 'Exclusive access to corporate rates and monthly discounts automatically applied at checkout for verified members.',
    },
    {
      icon: 'ri-database-2-line',
      title: 'AI-Enhanced Data',
      description: 'Verification fuels our AI engine with reliable data, continuously sharpening predictive capabilities for better service.',
    },
    {
      icon: 'ri-shield-user-line',
      title: 'Trust & Safety',
      description: 'Build confidence knowing every community member has been verified, creating a safer carpooling environment.',
    },
  ];

  return (
    <section id="verified-community" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center bg-amber-100 rounded-full px-4 py-2 mb-6">
              <i className="ri-verified-badge-line text-amber-600 mr-2 w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs font-medium text-amber-700" style={{ fontFamily: "'Inter', sans-serif" }}>
                Verified Community Model
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Trust Built on<br />Verification
            </h2>
            <p className="text-base text-gray-600 mb-8 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
              What truly distinguishes our platform is the verified community model. Every member is confirmed through car ownership records, granting access to exclusive benefits while building a foundation of trust that powers our AI capabilities.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-10 h-10 bg-teal-50 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${benefit.icon} text-lg text-teal-600 w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      {benefit.title}
                    </h4>
                    <p className="text-xs text-gray-600 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[500px] rounded-2xl overflow-hidden shadow-lg border border-gray-100">
              <img
                src="https://public.readdy.ai/ai/img_res/9688f4b6099e5d055f84e1b70736abac.jpg"
                alt="Verified Community Interface"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-lg p-4 shadow-md border border-gray-100">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-check-double-line text-2xl text-green-600 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500" style={{ fontFamily: "'Inter', sans-serif" }}>Verification Rate</p>
                  <p className="text-lg font-bold text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>100% Verified</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
